import { Tag } from "@aurem/ui";
import { useI18n } from "providers/I18nProvider";
import { WorkflowRunStatus } from "types";

export const WorkflowRunStatusTag = ({
  status,
}: {
  status: WorkflowRunStatus | null | undefined;
}) => {
  const { t } = useI18n();
  if (!status) return "-";

  const labels: Record<WorkflowRunStatus, string> = {
    Created: t("apps.admin.internalResources.workflowRun.statuses.created"),
    Running: t("apps.admin.internalResources.workflowRun.statuses.running"),
    Pending: t("apps.admin.internalResources.workflowRun.statuses.pending"),
    Blocked: t("apps.admin.internalResources.workflowRun.statuses.blocked"),
    Completed: t("apps.admin.internalResources.workflowRun.statuses.completed"),
    Failed: t("apps.admin.internalResources.workflowRun.statuses.failed"),
    Exited: t("apps.admin.internalResources.workflowRun.statuses.exited"),
  };

  const colors: Record<
    WorkflowRunStatus,
    "neutral" | "primary" | "warning" | "success" | "danger"
  > = {
    Created: "neutral",
    Running: "primary",
    Pending: "warning",
    Blocked: "danger",
    Completed: "success",
    Failed: "danger",
    Exited: "neutral",
  };

  return <Tag color={colors[status]} label={labels[status]} />;
};
